"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createCampaignReferenceResolver = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _createBatchedReferenceResolver = _interopRequireDefault(require("reference-resolvers/lib/createBatchedReferenceResolver"));

var _CacheKeys = _interopRequireDefault(require("reference-resolvers/constants/CacheKeys"));

var _CampaignsAPI = require("reference-resolvers/api/CampaignsAPI");

var createCampaignReferenceResolver = function createCampaignReferenceResolver(options) {
  return (0, _createBatchedReferenceResolver.default)((0, _extends2.default)({
    cacheKey: _CacheKeys.default.CAMPAIGNS,
    createFetchByIds: _CampaignsAPI.createFetchCampaignsById,
    fetchByIds: _CampaignsAPI.fetchCampaignsById
  }, options));
};

exports.createCampaignReferenceResolver = createCampaignReferenceResolver;

var _default = createCampaignReferenceResolver();

exports.default = _default;